import { render, staticRenderFns } from "./CreateDropshipper.vue?vue&type=template&id=a74245b8&scoped=true"
import script from "./CreateDropshipper.vue?vue&type=script&lang=js"
export * from "./CreateDropshipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74245b8",
  null
  
)

export default component.exports